import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

axios.defaults.headers.common["Content-Type"] = "application/json";

// FastAPI 422 returns detail as an array of {msg,...}; normalize to a string.
function cleanMsg(msg) {
  return String(msg).replace(/^Value error,\s*/i, "");
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "";
  if (typeof detail === "string") return cleanMsg(detail);
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? cleanMsg(e.msg) : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  }
  if (detail && typeof detail.msg === "string") return cleanMsg(detail.msg);
  return String(detail);
}

export default axios;
